import { useTranslation } from 'react-i18next';
import { useCallback, useMemo } from 'react';
import { languageMapping } from '../../localization/init';
import { useLanguage } from '../../_contexts/settings/settingsContext';
import { useConfigValuesState } from '../../hooks/useConfigValue';

export const useLanguageSettingsMessageBar = () => {
    const {
        setConfigValue,
        isLoading,
        isSuccess,
        isError,
        initialData: {
            configuration: { defaultLanguage },
        },
    } = useConfigValuesState();
    const [language, setLanguage] = useLanguage();
    const hasLanguageChanged = defaultLanguage !== language;

    const onSave = useCallback(() => {
        setConfigValue(config => {
            return {
                ...config,
                defaultLanguage: language,
            };
        });
    }, [language, setConfigValue]);

    const onRevert = useCallback(() => {
        setLanguage(defaultLanguage);
    }, [defaultLanguage, setLanguage]);

    return {
        language,
        hasLanguageChanged,
        onSave,
        onRevert,
        isLoading,
        isSuccess,
        isError,
    };
};

export const useLanguageGridConfig = () => {
    const { i18n } = useTranslation();
    const [language, setLanguage] = useLanguage();

    const languages = useMemo(() => Object.keys(i18n.options.resources), [i18n.options.resources]);

    const dropdownOptions = useMemo(
        () =>
            languages.map(lang => ({
                key: lang,
                text: languageMapping[lang].label,
            })),
        [languages],
    );

    const handleLanguageChange = useCallback(
        (_, option) => {
            if (option) {
                setLanguage(option.key);
            }
        },
        [setLanguage],
    );

    return {
        dropdownOptions,
        handleLanguageChange,
        currentLanguage: language,
    };
};
